"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveMetadata } from "@/generated/models/ApiWaveMetadata";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { getApproveWaveTabLabelsFromMetadata } from "@/helpers/waves/wave-metadata.helpers";
import { fetchWaveMetadata } from "@/services/api/waves-v2-api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useWaveMetadata(waveId, t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  let t4;
  if ($[2] !== waveId) {
    t3 = [QueryKey.WAVE_METADATA, {
      wave_id: waveId
    }];
    t4 = async () => {
      if (!waveId) {
        throw new Error("Cannot fetch wave metadata without a wave id");
      }
      return await fetchWaveMetadata({
        waveId
      });
    };
    $[2] = waveId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = Boolean(enabled && waveId);
  let t6;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 60000
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return useQuery(t6);
}
export function useApproveWaveCustomTabLabels(wave) {
  const $ = _c(4);
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  let t0;
  if ($[0] !== isApproveWave) {
    t0 = {
      enabled: isApproveWave
    };
    $[0] = isApproveWave;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useWaveMetadata(wave.id, t0);
  const t1 = isApproveWave ? data : null;
  let t2;
  if ($[2] !== t1) {
    t2 = getApproveWaveTabLabelsFromMetadata(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}